import { CategorySuggestion } from 'types/suggestions';
import { PinnedSuggestion } from 'types/model';

const SERVICES_PAGE_URL = '/uslugi/';

export const getDefaultListNavigablePinnedItems = (
  pinnedSuggestions: PinnedSuggestion[],
): CategorySuggestion[] => {
  const pinnedItems = pinnedSuggestions.map((pinned) => ({
    categoryUrl: pinned.url,
    categoryName: pinned.title,
    categoryLabel: pinned.description,
  }));

  const servicesPage: CategorySuggestion = {
    categoryUrl: SERVICES_PAGE_URL,
    categoryName: '',
    categoryLabel: '',
  };

  return [...pinnedItems, servicesPage];
};

export const getDefaultListPinnedOffset = (pinnedSuggestionsCount: number) => pinnedSuggestionsCount + 1;
